import React from "react";
import MuiDialog, { DialogProps } from '@mui/material/Dialog';
import { Paper, PaperProps } from "@mui/material";
import Draggable from "react-draggable";

export interface IDialogProps extends DialogProps { };

const PaperComponent = (props: PaperProps): JSX.Element => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const Dialog = (props: IDialogProps): JSX.Element => {
  const scroll: DialogProps['scroll'] = "paper";

  return (
    <MuiDialog
      {...props}
      scroll={scroll}
      PaperComponent={PaperComponent}
      sx={{ ...props.sx, m: 0, p: 0 }}
    />
  );
};

export default Dialog;
